import { useCallback, useMemo } from 'react';
import toast from 'react-hot-toast';

import { useClient } from '@/hooks/useClient';
import { getShareLink } from '@/utils/share';

import Button from '../Button';
import Icon from '../Icon';
import Text from '../Text';

const ShareBlogVia = () => {
  const { isClient } = useClient();
  const shareLinks = useMemo(
    () =>
      isClient
        ? [
            {
              name: 'Facebook',
              icon: 'streamline:facebook-1-solid',
              url: getShareLink('facebook'),
            },
            {
              name: 'LinkedIn',
              icon: 'bi:linkedin',
              url: getShareLink('linkedin'),
            },
            {
              name: 'X',
              icon: 'pajamas:twitter',
              url: getShareLink('x'),
            },
          ]
        : [],
    [isClient]
  );

  const handleNativeShare = useCallback(async () => {
    if (isClient)
      await navigator.share({
        url: window.location.href,
      });
  }, [isClient]);

  const isAppleDevice = useMemo(() => {
    if (!isClient) return;
    const userAgent = window.navigator.userAgent.toLowerCase();
    return (
      userAgent.includes('iphone') ||
      userAgent.includes('ipad') ||
      userAgent.includes('ipod')
    );
  }, [isClient]);

  return (
    <>
      <div className="flex w-full items-center justify-center md:hidden">
        <Button
          onClick={() => handleNativeShare()}
          variant="communityRectangular"
          suffixIcon={
            isAppleDevice
              ? 'material-symbols-light:ios-share-rounded'
              : 'material-symbols-light:share'
          }
        >
          <Text variant="jb-body-large">Share this post</Text>
        </Button>
      </div>
      <div className="hidden flex-col items-center gap-6 py-10 md:flex">
        <Text variant="h5" className="font-semibold">
          Share this blog post via
        </Text>
        <div className="flex flex-row items-start gap-8">
          <Button
            variant="unstyled"
            size="xs"
            className="flex flex-col items-center justify-center gap-2  text-jb-primary-600 transition-colors hover:cursor-pointer hover:text-jb-primary-400"
            onClick={() => {
              navigator.clipboard.writeText(window.location.href);
              toast.success('Link copied to clipboard');
            }}
          >
            <Icon icon="fontisto:world-o" fontSize={30} />

            <Text
              variant="jb-body-small"
              className="text-wrap w-14 text-center text-jb-neutral-1000"
            >
              Link to this page
            </Text>
          </Button>
          {shareLinks.map(({ icon, url, name }) => (
            <a
              key={url}
              target="_blank"
              href={url}
              className="flex w-14 flex-col items-center justify-center gap-2 text-jb-primary-600 transition-colors hover:cursor-pointer hover:text-jb-primary-400"
            >
              <Icon icon={icon} fontSize={30} />
              <Text variant="jb-body-small" className="text-jb-neutral-1000">
                {name}
              </Text>
            </a>
          ))}
        </div>
      </div>
    </>
  );
};

export default ShareBlogVia;
